export const langPickerControll = classNames => {
  
  var langPicker;
  var menuOpened = false;

  langPicker = $(classNames);

  langPicker.click(() => {

    if (menuOpened) {
      langPicker.removeClass('menuOpened');
    } else {
      langPicker.addClass('menuOpened');
    }

    menuOpened = !menuOpened;
  });

  langPicker.find('.chooser > li').each(function () {
    if ($(this).find(".sub_chooser").length) {
      $(this).click(e => {
        e.preventDefault();
        e.stopPropagation();
        $(this)[0].classList.toggle("opened")
      })

      $(this).find('.sub_chooser a').each(function () {
        $(this).click(function () {
          window.location.href = $(this).attr('href');
          menuOpened = false;
          langPicker.removeClass('menuOpened');
        })
      })
    }
  })
}